import { render } from "./NothingToSee.vue?vue&type=template&id=23fdae8c&scoped=true"
import script from "./NothingToSee.vue?vue&type=script&lang=js"
export * from "./NothingToSee.vue?vue&type=script&lang=js"

import "./NothingToSee.vue?vue&type=style&index=0&id=23fdae8c&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fdae8c"]])

export default __exports__